import { SvgIcon, SvgIconProps } from '@mui/material';

const FileIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M30 30.75C30 32.4069 28.6569 33.75 27 33.75H9C7.34315 33.75 6 32.4069 6 30.75V5.25C6 3.59315 7.34315 2.25 9 2.25H21.2574C22.053 2.25 22.8161 2.56607 23.3787 3.12868L29.1213 8.87132C29.6839 9.43393 30 10.197 30 10.9926V30.75Z"
          fill="#00733B"
        />
        <path d="M28.875 10.5H21.75V3.375L28.875 10.5Z" fill="#4D9D76" />
        <path
          d="M12 15.75H24.75V17.25H12V15.75ZM12 18.75H21.75V20.25H12V18.75ZM12 21.75H24.75V23.25H12V21.75ZM12 24.75H21.75V26.25H12V24.75Z"
          fill="white"
        />
      </svg>
    </SvgIcon>
  );
};

export default FileIcon;
